import type { AppState } from 'types/app';

export const selectPageView = (state: AppState) => state?.pageView;

export const selectPageType = (state: AppState) => selectPageView(state)?.pageType;

export const selectIsPageTypeLoaded = (state: AppState) => selectPageView(state)?.isPageTypeLoaded;
